"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const utils_1 = require("../../../utils");
const OfflineIndicator_1 = __importDefault(require("../../atoms/OfflineIndicator"));
const hooks_1 = require("../../hooks");
const DiversitySettingsPreviewPage = () => {
    const { state } = (0, hooks_1.useDiversityOverlay)();
    const { t } = (0, i18n_1.useTranslation)();
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const { selectedSkinTone, selectedPhenotype, selectedSex } = state;
    const image = `${selectedSex}_head_${selectedPhenotype}-${selectedSkinTone}`;
    const warningMassage = isOffline
        ? t(i18n_1.Strings.diversity.offlineMessage)
        : t(i18n_1.Strings.diversity.switchingChoice);
    return ((0, jsx_runtime_1.jsxs)(ContentContainer, { "data-e2e": 'ContentContainer', children: [(0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'Container', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: true, appear: true, timeout: 100, classNames: "background", "data-e2e": 'CSSTransition', children: (0, jsx_runtime_1.jsx)(ImageContainer, { "data-e2e": 'ImageContainer', children: (0, jsx_runtime_1.jsx)(Image, { src: (0, utils_1.getImage)(image), "aria-label": image, alt: "face_preview", "data-e2e": 'Image' }) }) }) }), isOffline && ((0, jsx_runtime_1.jsxs)(PreviewWarningContainer, { "data-e2e": 'PreviewWarningContainer', children: [(0, jsx_runtime_1.jsx)(StyledOfflineIndicator, { "data-e2e": 'StyledOfflineIndicator' }), warningMassage] }))] }));
};
exports.default = DiversitySettingsPreviewPage;
const Container = styled_components_1.default.div `
  position: relative;

  z-index: 1;

  width: 316px;
  height: 316px;

  margin: auto;

  overflow: hidden;

  border-radius: 50%;

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    margin: 30px auto 50px;

    width: 444px;
    height: 444px;
  `)};
`;
const ImageContainer = styled_components_1.default.div `
  position: absolute;

  top: 18px;
  left: 18px;

  width: 280px;
  height: 280px;

  margin: 0 auto;

  overflow: hidden;

  border-radius: 50%;

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    top: 24px;
    left: 24px;

    width: 396px;
    height: 396px;
  `)};

  &:after {
    position: absolute;

    top: 0;
    left: 0;
    z-index: -1;

    width: 280px;
    height: 280px;
    margin: 0 auto;

    background: ${({ theme }) => theme.green};
    border-radius: 50%;
    transform: scale(0.1);

    content: '';

    ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
      width: 396px;
      height: 396px;
    `)};
  }

  &.background-enter-done:after {
    transform: scale(1);

    transition: transform 1s;
  }
`;
const Image = styled_components_1.default.img `
  position: relative;
  top: 24px;
  left: 43px;

  width: 194px;
  height: 263px;

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    top: 25px;
    left: 60.5px;

    width: 275px;
    height: 373px;
  `)};
`;
const ContentContainer = styled_components_1.default.div `
  position: static;

  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    flex-direction: column;
    height: 84vh;
    width: 100vw;
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    height: 92vh;
    flex-direction: column;
    overflow: hidden;
  `)}

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    height: 86vh;
  `)}

  ${ui_1.deviceLandscape.laptopL((0, styled_components_1.css) `
    height: 70vh;
    margin-bottom: 140px;

    overflow: visible;
  `)}
`;
const WarningContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  width: 100vw;

  color: ${({ theme }) => theme.settings.text};

  font-size: 14px;
  text-align: center;

  ${({ isThirdPage }) => ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
      position: relative;
      flex-direction: column;
      align-items: center;
      width: auto;
      height: 50px;
      margin: ${isThirdPage ? '40px 20px 20px' : '42px 20px 50px'};
      bottom: ${isThirdPage ? 10 : 124}px;
    `)};

  ${({ isThirdPage }) => ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
      display: ${isThirdPage ? 'none' : 'block'};
      position: relative;
      flex-direction: column;
      align-items: center;
      left: 55vw;
      bottom: 180px;
      width: 256px;
    `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    /** z-index required for Windows @see https://elsevier.atlassian.net/browse/E3D4M-21062 */
    z-index: 19;
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    display: block;
    position: absolute;
    flex-direction: row;
    align-items: flex-start;
    left: calc(50% - 166px);
    bottom: 10px;
    width: 332px;
    height: 42px;
    line-height: 20px;
  `)};

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    left: calc(50% - 200px);
    width: 400px;
  `)};
`;
const PreviewWarningContainer = (0, styled_components_1.default)(WarningContainer) `
  display: flex;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    bottom: 0;
    margin: 0 20px;
  `)};

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    left: calc(50% - 300px);
    width: 600px;
  `)};
`;
const StyledOfflineIndicator = (0, styled_components_1.default)(OfflineIndicator_1.default) `
  width: 14px;
  height: 14px;

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: 0 auto;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    display: inline-block;

    margin: 2px;
  `)};
`;
